/* eslint-disable indent */
import { ACCOUNT_INITIALIZE, LOGIN, LOGOUT } from './actions';
import { updateCurrentToken } from '../utils/axios';

export const initialState = {
    token: '',
    isLoggedIn: false,
    isInitialized: false,
    user: null,
    homepage: '/home',
    scopes: [],
};

const accountReducer = (state = initialState, action) => {
    switch (action.type) {
    case ACCOUNT_INITIALIZE: {
        const {
            isLoggedIn,
            user,
            token,
            homepage,
            scopes,
        } = action.payload;
        
        console.log('🔴 ACCOUNT_INITIALIZE reducer called');
        console.log('   New token:', token?.substring(0, 30) + '...');
        console.log('   New user.org:', user?.org);
        console.log('   New user.access_token:', user?.access_token?.substring(0, 30) + '...');
        console.log('   Scopes count:', scopes?.length);
        
        const newState = {
            ...state,
            isLoggedIn,
            isInitialized: true,
            token,
            user,
            homepage,
            scopes: scopes || state.scopes,
        };
        
        // CRITICAL: Immediately update axios interceptor with new token
        // This ensures the interceptor has the latest token BEFORE any API calls
        updateCurrentToken(newState);
        console.log('✅ Axios token updated from reducer');
        
        return newState;
    }
    case LOGIN: {
        const { user } = action.payload;
        return {
            ...state,
            isLoggedIn: true,
            user,
        };
    }
    case LOGOUT: {
        return {
            ...state,
            isLoggedIn: false,
            token: null,
            user: null,
        };
    }
    default: {
        return { ...state };
    }
    }
};

export default accountReducer;
